const ITEMS = [
  "Pickleball-First Agency",
  "Athlete Branding",
  "Sponsorship Development",
  "NIL Opportunities",
  "Media & Content",
  "Career Management",
  "Carlsbad, CA",
];

const SPECTRUM = ["#2563eb", "#06b6d4", "#10b981", "#84cc16", "#facc15", "#f97316", "#ef4444"];

function Strip() {
  return (
    <div className="flex shrink-0 items-center gap-10 pr-10">
      {ITEMS.map((t, i) => (
        <span key={t} className="flex items-center gap-10">
          <span className="whitespace-nowrap font-display text-2xl uppercase text-white/90 sm:text-3xl">
            {t}
          </span>
          <span
            className="h-2.5 w-2.5 shrink-0 rounded-full"
            style={{ backgroundColor: SPECTRUM[i % SPECTRUM.length] }}
          />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative overflow-hidden py-8" data-testid="editorial-marquee">
      <div className="-mx-4 -rotate-1 border-y border-white/10 bg-surface py-5">
        <div className="animate-marquee flex w-max">
          <Strip />
          <Strip />
        </div>
      </div>
    </div>
  );
}
